const progressConstants = {
    SET_PROGRESS: 'PROGRESS_SET_PROGRESS',
    REMOVE_PROGRESS: 'PROGRESS_REMOVE_PROGRESS',
};

export default progressConstants;
